export default "__VITE_ASSET__CAAsTV3t__"